import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiAvatarComponent } from '../../atoms/avatar/avatar.component';
import { UiButtonComponent } from '../../atoms/button/button.component';

/**
 * Molécula: tarjeta de contacto con foto, nombre, rol, datos y acciones.
 */
@Component({
  selector: 'ui-contact-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiAvatarComponent, UiButtonComponent],
  templateUrl: './contact-card.component.html',
  styleUrl: './contact-card.component.scss',
  host: { class: 'ui-contact-card-host' },
})
export class UiContactCardComponent {
  readonly name = input.required<string>();
  readonly role = input.required<string>();
  readonly photo = input('');
  readonly email = input('');
  readonly phone = input('');
}
